var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dashboard-block" },
    [
      _vm.canDeleteUser
        ? _c(
            "ladda-button",
            {
              key: "delete",
              staticClass: "btn btn-sm btn-danger",
              attrs: {
                type: "button",
                click: _vm.handleDeleteUserCallback,
                disabled: _vm.userIsAdmin && !_vm.canEditAdmin,
              },
            },
            [
              _c("i", { staticClass: "fa fa-trash" }),
              _vm._v(" Delete Account\n  "),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canPerformAdministrativeActions
        ? [
            _vm.userIsDeleted
              ? _c(
                  "ladda-button",
                  {
                    key: "restore",
                    staticClass: "btn btn-sm btn-info",
                    attrs: {
                      click: _vm.handleRestoreUserCallback,
                      done: _vm.handleRestoreUserDoneCallback,
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-refresh" }),
                    _vm._v(
                      " Restore " + _vm._s(_vm.userDisplayRole) + "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canPermanentlyDeleteUser
              ? _c(
                  "ladda-button",
                  {
                    key: "permanentlyDelete",
                    staticClass: "btn btn-sm btn-danger",
                    attrs: { click: _vm.handlePermanentlyDeleteUserCallback },
                  },
                  [
                    _c("i", { staticClass: "fa fa-trash" }),
                    _vm._v(
                      " Permanently Delete " +
                        _vm._s(_vm.userDisplayRole) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canVerifyUser
              ? _c(
                  "ladda-button",
                  {
                    key: "verify",
                    staticClass: "btn btn-sm btn-success",
                    attrs: {
                      click: _vm.handleVerifyUserCallback,
                      disabled: _vm.userIsAdmin && !_vm.canEditAdmin,
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-check" }),
                    _vm._v(
                      " Verify " + _vm._s(_vm.userDisplayRole) + " Email\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canActivateUser
              ? _c(
                  "ladda-button",
                  {
                    key: "activate",
                    staticClass: "btn btn-sm btn-success",
                    attrs: { click: _vm.handleActivateUserCallback },
                  },
                  [
                    _c("i", { staticClass: "fa fa-check" }),
                    _vm._v(
                      " Activate " + _vm._s(_vm.userDisplayRole) + "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canActivateUser && _vm.$vlastMode
              ? _c(
                  "ladda-button",
                  {
                    key: "resendActivationEmail",
                    staticClass: "btn btn-sm btn-success",
                    attrs: { click: _vm.handleResendActivationEmail },
                  },
                  [
                    _c("i", { staticClass: "fa fa-check" }),
                    _vm._v(" Send Activation Email\n    "),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canActivateUser && _vm.$vlastMode
              ? _c(
                  "ladda-button",
                  {
                    key: "handleSendActivationSMS",
                    staticClass: "btn btn-sm btn-success",
                    attrs: { click: _vm.handleSendActivationSMS },
                  },
                  [
                    _c("i", { staticClass: "fa fa-check" }),
                    _vm._v(" Send SMS Activation\n    "),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canDeactivateUser
              ? _c(
                  "ladda-button",
                  {
                    key: "deactivate",
                    staticClass: "btn btn-sm btn-danger",
                    attrs: { click: _vm.handleDeactivateUserCallback },
                  },
                  [
                    _c("i", { staticClass: "fa fa-ban" }),
                    _vm._v(
                      " Deactivate " + _vm._s(_vm.userDisplayRole) + "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.$vlastMode && _vm.$userIsClient
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn-sm btn-info",
                    attrs: { href: _vm.createNewRequestLink },
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v(" Create New Request"),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.$vlastMode &&
      _vm.user.role === "talent" &&
      _vm.user.status === "active" &&
      _vm.user.profile &&
      _vm.user.profile.visibility === "public"
        ? _c(
            "a",
            {
              staticClass: "btn btn-sm btn-info",
              attrs: { href: _vm.viewPublicProfileLink, target: "_blank" },
            },
            [
              _c("i", { staticClass: "fa fa-arrow-circle-right" }),
              _vm._v(" View Public Profile"),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }